import { gql } from '@apollo/client';

export const getPopularLocation = gql`
    query getPopularLocation($currentPage: Int) {
      getPopularLocation(currentPage: $currentPage) {
        count
        results {
          id
          location
          locationAddress
          image
          isEnable
          createdAt
          updatedAt
          status
        }
      }
    }
    `;

export const deletePopularLocation = gql`
    mutation deletePopularLocation ($id: Int!) {
      deletePopularLocation (id: $id) {
          status
        }
      }
    `;

export const updatePopularLocationStatusMutation = gql`
    mutation updatePopularLocationStatus ($id: Int, $isEnable: String){
      updatePopularLocationStatus(id: $id, isEnable: $isEnable){
            status
        }
    }
    `;

export const editPopularLocation = gql`
    query editPopularLocation ($id: Int!) {
      editPopularLocation (id: $id) {
          id
          location
          locationAddress
          isEnable
          image
      }
    }
    `;

export const uploadLocationMutation = gql`
    mutation uploadLocation(
      $id: Int,
      $image: String,
    ) {
      uploadLocation(
        id: $id,
        image: $image,
      ) {
          status
      }
    }
    `;

export const removeLocationMutation = gql`
    mutation removeLocation(
      $id: Int!,
      $image: String,
    ) {
      removeLocation(
        id: $id,
        image: $image,
      ) {
          status
      }
    }
    `;


export const updatePopularLocation = `mutation updatePopularLocation(
    $id: Int,
    $location: String,
    $locationAddress: String,
    $image: String,
  ) {
    updatePopularLocation(
      id: $id,
      location: $location,
      locationAddress: $locationAddress,
      image: $image,
    ) {
        status
    }
  }`